import { createActionCreator } from "common/ReduxUtils";
import { InboundShipmentActionTypes } from "inbounds/store/actions/shipment/InboundShipmentActionTypes";

export const clearRates = createActionCreator(InboundShipmentActionTypes.CLEAR_RATES);
